import { GemIcon2 } from "@/components/icons";
import { cn, formatThousands } from "@/lib/utils";
import { type OrderProduct } from "./api";

// 钻石包卡片组件
export default function GemPackCard({
	item,
	selected,
	onClick,
}: {
	item: OrderProduct;
	selected: boolean;
	onClick: () => void;
}) {
	return (
		<div
			key={item.price}
			className={cn(
				"group relative rounded-[14px] shadow-card p-3 flex-1 flex flex-col items-center cursor-pointer transition-all bg-linear-to-b from-[#FFF5FC] to-[#FFF] dark:from-[#434042] dark:to-[#161515]",
			)}
			onClick={onClick}
		>
			<img
				src="/assets/images/deposit/card-bg-1.svg"
				alt="gem"
				className="w-[85%] hidden md:block absolute top-4 z-0 dark:opacity-20"
			/>
			<div
				className={cn(
					"w-full h-full absolute rounded-[14px] transition-all duration-300 top-0 left-0 z-1 border-2 border-main1 opacity-0 group-hover:opacity-100",
					selected && "opacity-100",
				)}
			/>
			{item.discount_info && (
				<span className="absolute top-0 right-0 z-0 bg-c5/55 rounded-bl-[14px] rounded-tr-[14px] text-xs font-medium text-w1 px-2 h-[25px] flex items-center justify-center">
					{item.discount_info}
				</span>
			)}
			<div className="relative z-[2] flex flex-col items-center w-full gap-3">
				<GemIcon2 className="w-[55px] h-[55px] mt-2" />
				<div
					className="text-lg mb-2 text-[#B37689] text-[20
				px] leading-6 md:text-[24px] md:leading-6 font-black"
				>
					{formatThousands(item.product_amount)}
				</div>
				<div className="w-full h-10 text-[#91467F] dark:text-t2 text-lg leading-5 font-bold flex items-center justify-center rounded-full bg-linear-to-b from-[#FAEAF6] to-[#FFF2FC] dark:bg-none dark:bg-[#4A4A4A]">
					<div className="flex items-end gap-1 text-sm md:text-base">
						<span className="text-xs font-medium relative -top-[3.5px]">
							{item.currency_symbol}
						</span>
						{formatThousands(item.price)}
					</div>
				</div>
			</div>
		</div>
	);
}
